import { TabContent, TabHeader } from "@components/views/tabs-view";

import Breadcrumbs from "@components/ui-components/breadcrumbs";
import CompaniesList from "./tabs/companies";
import { People } from "./tabs/people";
import { Stages } from "./tabs/stages";
import useCompanies from "./use-companies";

function Companies () {
    
    const { active, toggle } = useCompanies();

    const TabsList = [
        {
            id     : "companies",
            name   : "Companies",
            content: <CompaniesList />
        },
        {
            id     : "stages",
            name   : "Stages",
            content: <Stages />
        },
        {
            id     : "people",
            name   : "People",
            content: <People />
        }
    ];
    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Companies",
                        active: true
                    }
                ]}
                bottomChildren={
                    <TabHeader
                        active={active}
                        toggle={toggle}
                        tabs={TabsList}/>
                }/>
            <TabContent active={active} tabs={TabsList}/>
        </>
    );
}

export default Companies;
